import { create, tsx } from '@dojo/framework/core/vdom';
import * as css from './OSSLinks.m.css';
import { Link } from '@dojo/framework/routing/Link';
import { Text } from './Text';

const dojoLogo = require('../assets/images/logo/oss/dojo.png');
const dojoLogoLight = require('../assets/images/logo/oss/dojo-white-bg.png');
const internLogo = require('../assets/images/logo/oss/intern.jpg');
const internLogoLight = require('../assets/images/logo/oss/intern-white-bg.png');
const tsLogo = require('../assets/images/logo/oss/typescript.png');
const tsLogoLight = require('../assets/images/logo/oss/ts-white-bg.png');
const dojoToolkitLogo = require('../assets/images/logo/oss/dojo-toolkit.png');
const dojoToolkitLogoLight = require('../assets/images/logo/oss/dojo-toolkit-white-bg.png');
const dgridLogo = require('../assets/images/logo/oss/dgrid.png');
const dgridLogoLight = require('../assets/images/logo/oss/dgrid-white-bg.png');

interface OSSLinksProperties {
	light?: boolean;
}

const factory = create().properties<OSSLinksProperties>();

export const OSSLinks = factory(function OSSLinks({ properties }) {
	const { light = false } = properties();
	return (
		<div>
			<Text type="callout-head" responsive="section" align="center">
				Open Source Software Development
			</Text>
			<p classes={css.intro}>
				With over a decade of experience developing large-scale web applications, SitePen
				creates, maintains, and contributes to open source software that prioritizes the
				needs of enterprises and developers alike.
			</p>
			<ul classes={css.list}>
				<li classes={css.item}>
					<Link to="opensourceDojo">
						<img
							loading="lazy"
							classes={css.img}
							src={light ? dojoLogoLight : dojoLogo}
							alt="Dojo"
						/>
					</Link>
				</li>
				<li classes={css.item}>
					<Link to="opensourceIntern">
						<img
							loading="lazy"
							classes={css.img}
							src={light ? internLogoLight : internLogo}
							alt="Intern"
						/>
					</Link>
				</li>
				<li classes={css.item}>
					<Link to="opensourceTypescript">
						<img
							loading="lazy"
							classes={css.img}
							src={light ? tsLogoLight : tsLogo}
							alt="TypeScript"
						/>
					</Link>
				</li>
				<li classes={css.item}>
					<Link to="opensourceDojoToolkit">
						<img
							loading="lazy"
							classes={css.img}
							src={light ? dojoToolkitLogoLight : dojoToolkitLogo}
							alt="Dojo Toolkit"
						/>
					</Link>
				</li>
				<li classes={css.item}>
					<Link to="opensourceDgrid">
						<img
							loading="lazy"
							classes={css.img}
							src={light ? dgridLogoLight : dgridLogo}
							alt="dgrid"
						/>
					</Link>
				</li>
			</ul>
		</div>
	);
});

export default OSSLinks;
